/* @generated */
// prettier-ignore
if (Intl.DisplayNames && typeof Intl.DisplayNames.__addLocaleData === 'function') {
  Intl.DisplayNames.__addLocaleData({
  "data": {
    "patterns": {
      "locale": "{0} ({1})"
    },
    "types": {
      "calendar": {
        "long": {
          "buddhist": "Buddist senenamasy",
          "chinese": "Hytaý senenamasy",
          "coptic": "coptic",
          "dangi": "Dangi senenamasy",
          "ethiopic": "Efiop senenamasy",
          "ethiopic-amete-alem": "ethiopic-amete-alem",
          "gregorian": "Grigorian senenamasy",
          "hebrew": "Ýewreý senenamasy",
          "indian": "indian",
          "islamic": "Hijri-kamary senenamasy",
          "islamic-civil": "islamic-civil",
          "islamic-rgsa": "islamic-rgsa",
          "islamic-tbla": "islamic-tbla",
          "islamic-umalqura": "islamic-umalqura",
          "iso8601": "ISO-8601 senenamasy",
          "japanese": "Ýapon senenamasy",
          "persian": "Pars senenamasy",
          "roc": "Minguo senenamasy"
        },
        "narrow": {
        },
        "short": {
        }
      },
      "currency": {
        "long": {
          "ADP": "ADP",
          "AED": "BAE dirhemi",
          "AFA": "AFA",
          "AFN": "Owgan afganisi",
          "ALK": "ALK",
          "ALL": "Alban leki",
          "AMD": "Ermeni dramy",
          "ANG": "Niderland antil guldeni",
          "AOA": "Angola kwanzasy",
          "AOK": "AOK",
          "AON": "AON",
          "AOR": "AOR",
          "ARA": "ARA",
          "ARL": "ARL",
          "ARM": "ARM",
          "ARP": "ARP",
          "ARS": "Argentin pesosy",
          "ATS": "ATS",
          "AUD": "Awstraliýa dollary",
          "AWG": "Aruba florini",
          "AZM": "AZM",
          "AZN": "Azerbaýjan manady",
          "BAD": "BAD",
          "BAM": "Konwertirlenýän Bosniýa we Gersegowina markasy",
          "BAN": "BAN",
          "BBD": "Barbados dollary",
          "BDT": "Bangladeş takasy",
          "BEC": "BEC",
          "BEF": "BEF",
          "BEL": "BEL",
          "BGL": "BGL",
          "BGM": "BGM",
          "BGN": "Bolgar lewi",
          "BGO": "BGO",
          "BHD": "Bahreýn dinary",
          "BIF": "Burundi franky",
          "BMD": "Bermuda dollary",
          "BND": "Bruneý dollary",
          "BOB": "Boliwiýa boliwianosy",
          "BOL": "BOL",
          "BOP": "BOP",
          "BOV": "BOV",
          "BRB": "BRB",
          "BRC": "BRC",
          "BRE": "BRE",
          "BRL": "Brazil realy",
          "BRN": "BRN",
          "BRR": "BRR",
          "BRZ": "BRZ",
          "BSD": "Bagama dollary",
          "BTN": "Butan ngultrumy",
          "BUK": "BUK",
          "BWP": "Botswana pulasy",
          "BYB": "BYB",
          "BYN": "Belarus rubly",
          "BYR": "Belorus rubly (2000–2016)",
          "BZD": "Beliz dollary",
          "CAD": "Kanada dollary",
          "CDF": "Kongo franky",
          "CHE": "CHE",
          "CHF": "Şweýsar franky",
          "CHW": "CHW",
          "CLE": "CLE",
          "CLF": "CLF",
          "CLP": "Çili pesosy",
          "CNH": "Hytaý ýuany (ofşor)",
          "CNX": "CNX",
          "CNY": "Hytaý ýuany",
          "COP": "Kolumbiýa pesosy",
          "COU": "COU",
          "CRC": "Kosta-Rika kolony",
          "CSD": "CSD",
          "CSK": "CSK",
          "CUC": "Konwertirlenýän kuba pesosy",
          "CUP": "Kuba pesosy",
          "CVE": "Kabo-Werde eskudosy",
          "CYP": "CYP",
          "CZK": "Çeh kronasy",
          "DDM": "DDM",
          "DEM": "DEM",
          "DJF": "Jibuti franky",
          "DKK": "Daniýa kronasy",
          "DOP": "Dominikan pesosy",
          "DZD": "Alžir dinary",
          "ECS": "ECS",
          "ECV": "ECV",
          "EEK": "EEK",
          "EGP": "Müsür funty",
          "ERN": "Eritreýa nakfasy",
          "ESA": "ESA",
          "ESB": "ESB",
          "ESP": "ESP",
          "ETB": "Efiopiýa byry",
          "EUR": "Ýewro",
          "FIM": "FIM",
          "FJD": "Fiji dollary",
          "FKP": "Folklend adalarynyň funty",
          "FRF": "FRF",
          "GBP": "Britan funt sterlingi",
          "GEK": "GEK",
          "GEL": "Gruzin larisi",
          "GHC": "GHC",
          "GHS": "Gano sedisi",
          "GIP": "Gibraltar funty",
          "GMD": "Gambiýa dalasisi",
          "GNF": "Gwineý franky",
          "GNS": "GNS",
          "GQE": "GQE",
          "GRD": "GRD",
          "GTQ": "Gwatemala ketsaly",
          "GWE": "GWE",
          "GWP": "GWP",
          "GYD": "Gaýana dollary",
          "HKD": "Gonkong dollary",
          "HNL": "Gonduras lempirasy",
          "HRD": "HRD",
          "HRK": "Horwat kunasy",
          "HTG": "Gaiti gurdy",
          "HUF": "Wenger forinti",
          "IDR": "Indoneziýa rupiýasy",
          "IEP": "IEP",
          "ILP": "ILP",
          "ILR": "ILR",
          "ILS": "Täze Ysraýyl şekeli",
          "INR": "Hindi rupiýasy",
          "IQD": "Yrak dinary",
          "IRR": "Eýran rialy",
          "ISJ": "ISJ",
          "ISK": "Islandiýa kronasy",
          "ITL": "ITL",
          "JMD": "Ýamaýka dollary",
          "JOD": "Iordan dinary",
          "JPY": "Ýapon ýeni",
          "KES": "Keniýa şillingi",
          "KGS": "Gyrgyz somy",
          "KHR": "Kamboja riýeli",
          "KMF": "Komor adalarynyň franky",
          "KPW": "Demirgazyk Koreý wony",
          "KRH": "KRH",
          "KRO": "KRO",
          "KRW": "Günorta Koreý wony",
          "KWD": "Kuweýt dinary",
          "KYD": "Kaýman adalarynyň dollary",
          "KZT": "Gazak teňňesi",
          "LAK": "Laos kipi",
          "LBP": "Liwan funty",
          "LKR": "Şri-Lanka rupiýasy",
          "LRD": "Liberiýa dollary",
          "LSL": "Lesoto lotisi",
          "LTL": "LTL",
          "LTT": "LTT",
          "LUC": "LUC",
          "LUF": "LUF",
          "LUL": "LUL",
          "LVL": "LVL",
          "LVR": "LVR",
          "LYD": "Liwiýa dinary",
          "MAD": "Marokko dirhamy",
          "MAF": "MAF",
          "MCF": "MCF",
          "MDC": "MDC",
          "MDL": "Moldaw leýi",
          "MGA": "Malagasiý ariarisi",
          "MGF": "MGF",
          "MKD": "Makedon dinary",
          "MKN": "MKN",
          "MLF": "MLF",
          "MMK": "Mýanma kýaty",
          "MNT": "Mongol tugrigi",
          "MOP": "Makao patakasy",
          "MRO": "Mawritan ugiýasy (1973–2017)",
          "MRU": "Mawritan ugiýasy",
          "MTL": "MTL",
          "MTP": "MTP",
          "MUR": "Mawrikiý rupiýasy",
          "MVP": "MVP",
          "MVR": "Maldiw rufiýasy",
          "MWK": "Malawi kwaçasy",
          "MXN": "Meksikan pesosy",
          "MXP": "MXP",
          "MXV": "MXV",
          "MYR": "Malaýziýa ringgiti",
          "MZE": "MZE",
          "MZM": "MZM",
          "MZN": "Mozambik metikaly",
          "NAD": "Namibiýa dollary",
          "NGN": "Nigeriýa naýrasy",
          "NIC": "NIC",
          "NIO": "Nikaragua kordobasy",
          "NLG": "NLG",
          "NOK": "Norwegiýa kronasy",
          "NPR": "Nepal rupiýasy",
          "NZD": "Täze Zelandiýa dollary",
          "OMR": "Oman rialy",
          "PAB": "Panama balboasy",
          "PEI": "PEI",
          "PEN": "Peru soly",
          "PES": "PES",
          "PGK": "Papua - Täze Gwineýa kinasy",
          "PHP": "Filippin pesosy",
          "PKR": "Päkistan rupiýasy",
          "PLN": "Polýak zlotysy",
          "PLZ": "PLZ",
          "PTE": "PTE",
          "PYG": "Paragwaý guaranisi",
          "QAR": "Katar rialy",
          "RHD": "RHD",
          "ROL": "ROL",
          "RON": "Rumyn leýi",
          "RSD": "Serb dinary",
          "RUB": "Rus rubly",
          "RUR": "RUR",
          "RWF": "Ruanda franky",
          "SAR": "Saud rialy",
          "SBD": "Solomon adalarynyň dollary",
          "SCR": "Seýşel rupiýasy",
          "SDD": "SDD",
          "SDG": "Sudan funty",
          "SDP": "SDP",
          "SEK": "Şwed kronasy",
          "SGD": "Singapur dollary",
          "SHP": "Keramatly Ýelena adasynyň funty",
          "SIT": "SIT",
          "SKK": "SKK",
          "SLL": "Sýerra-Leone leony",
          "SOS": "Somali şillingi",
          "SRD": "Surinam dollary",
          "SRG": "SRG",
          "SSP": "Günorta Sudan funty",
          "STD": "San-Tome we Prinsipi dobrasy (1977–2017)",
          "STN": "San-Tome we Prinsipi dobrasy",
          "SUR": "SUR",
          "SVC": "SVC",
          "SYP": "Siriýa funty",
          "SZL": "Swazi lilangeni",
          "THB": "Taýland baty",
          "TJR": "TJR",
          "TJS": "Täjik somonisi",
          "TMM": "TMM",
          "TMT": "Türkmen manady",
          "TND": "Tunis dinary",
          "TOP": "Tonga paangasy",
          "TPE": "TPE",
          "TRL": "TRL",
          "TRY": "Türk lirasy",
          "TTD": "Trininad we Tobago dollary",
          "TWD": "Täze Taýwan dollary",
          "TZS": "Tanzaniýa şillingi",
          "UAH": "Ukrain griwnasy",
          "UAK": "UAK",
          "UGS": "UGS",
          "UGX": "Uganda şillingi",
          "USD": "ABŞ dollary",
          "USN": "USN",
          "USS": "USS",
          "UYI": "UYI",
          "UYP": "UYP",
          "UYU": "Urugwaý pesosy",
          "UYW": "UYW",
          "UZS": "Özbek somy",
          "VEB": "VEB",
          "VEF": "Wenesuela boliwary (2008–2018)",
          "VES": "Wenesuela boliwary",
          "VND": "Wýetnam dongy",
          "VNN": "VNN",
          "VUV": "Wanuatu watusy",
          "WST": "Samoa talasy",
          "XAF": "KFA BEAC franky",
          "XAG": "XAG",
          "XAU": "XAU",
          "XBA": "XBA",
          "XBB": "XBB",
          "XBC": "XBC",
          "XBD": "XBD",
          "XCD": "Gündogar karib dollary",
          "XDR": "XDR",
          "XEU": "XEU",
          "XFO": "XFO",
          "XFU": "XFU",
          "XOF": "KFA BCEAO franky",
          "XPD": "XPD",
          "XPF": "Fransuz ýuwaş umman franky",
          "XPT": "XPT",
          "XRE": "XRE",
          "XSU": "XSU",
          "XTS": "XTS",
          "XUA": "XUA",
          "XXX": "Näbelli pul birligi",
          "YDD": "YDD",
          "YER": "Ýemen rialy",
          "YUD": "YUD",
          "YUM": "YUM",
          "YUN": "YUN",
          "YUR": "YUR",
          "ZAL": "ZAL",
          "ZAR": "Günorta Afrika rendi",
          "ZMK": "ZMK",
          "ZMW": "Zambiýa kwaçasy",
          "ZRN": "ZRN",
          "ZRZ": "ZRZ",
          "ZWD": "ZWD",
          "ZWL": "ZWL",
          "ZWR": "ZWR"
        },
        "narrow": {
        },
        "short": {
        }
      },
      "dateTimeField": {
        "long": {
          "day": "gün",
          "dayOfYear": "ýylyň güni",
          "dayperiod": "günortadan öň/günortadan soň",
          "era": "era",
          "hour": "sagat",
          "minute": "minut",
          "month": "aý",
          "quarter": "çärýek",
          "second": "sekunt",
          "timeZoneName": "sagat guşaklygy",
          "weekOfMonth": "aýyň hepdesi",
          "weekOfYear": "hepde",
          "weekday": "hepdäniň güni",
          "weekdayOfMonth": "aýda hepdäň güni",
          "year": "ýyl"
        },
        "narrow": {
          "day": "gün",
          "dayOfYear": "ý. güni",
          "dayperiod": "GÖ/GS",
          "era": "era",
          "hour": "sag.",
          "minute": "min.",
          "month": "aý",
          "quarter": "çär.",
          "second": "sek.",
          "timeZoneName": "guşaklyk",
          "weekOfMonth": "hep./aý",
          "weekOfYear": "hep.",
          "weekday": "hep. güni",
          "weekdayOfMonth": "aýda hep. güni",
          "year": "ý."
        },
        "short": {
          "day": "gün",
          "dayOfYear": "ý. güni",
          "dayperiod": "GÖ/GS",
          "era": "era",
          "hour": "sag.",
          "minute": "min.",
          "month": "aý",
          "quarter": "çär.",
          "second": "sek.",
          "timeZoneName": "guşaklyk",
          "weekOfMonth": "hep./aý",
          "weekOfYear": "hep.",
          "weekday": "hep. güni",
          "weekdayOfMonth": "aýda hep. güni",
          "year": "ý."
        }
      },
      "language": {
        "dialect": {
          "long": {
            "aa": "afar dili",
            "ab": "abhaz dili",
            "ace": "açeh dili",
            "ada": "adangme dili",
            "ady": "adygeý dili",
            "af": "afrikaans dili",
            "agq": "ahem dili",
            "ain": "aýn dili",
            "ak": "akan dili",
            "ale": "aleut dili",
            "alt": "günorta Altaý dili",
            "am": "amhar dili",
            "an": "aragon dili",
            "anp": "angika dili",
            "ar": "arap dili",
            "ar-001": "häzirki zaman standart arap dili",
            "arn": "mapuçe dili",
            "arp": "arapaho dili",
            "as": "assam dili",
            "asa": "asu dili",
            "ast": "asturiý dili",
            "av": "awar dili",
            "awa": "awadhi dili",
            "ay": "aýmara dili",
            "az": "azerbaýjan dili",
            "ba": "başgyrt dili",
            "ban": "baliý dili",
            "bas": "basaa dili",
            "be": "belarus dili",
            "bem": "bemba dili",
            "bez": "bena dili",
            "bg": "bolgar dili",
            "bho": "bhojpuri dili",
            "bi": "bislama dili",
            "bin": "bini dili",
            "bla": "siksika dili",
            "bm": "bamana",
            "bn": "bengal dili",
            "bo": "tibet dili",
            "br": "breton dili",
            "brx": "bodo dili",
            "bs": "bosniýa dili",
            "bug": "bugiý dili",
            "byn": "blin dili",
            "ca": "katalan dili",
            "ccp": "çakma dili",
            "ce": "çeçen dili",
            "ceb": "sebuan dili",
            "cgg": "kiga",
            "ch": "çamorro",
            "chk": "çuuk dili",
            "chm": "mariý dili",
            "cho": "çokto",
            "chr": "çeroki",
            "chy": "şaýenn dili",
            "ckb": "merkezi kürt dili",
            "co": "korsikan dili",
            "crs": "seselwa kreole-fransuz dili",
            "cs": "çeh dili",
            "cu": "buthana slaw dili",
            "cv": "çuwaş dili",
            "cy": "walliý dili",
            "da": "daniýa dili",
            "dak": "dakota dili",
            "dar": "dargi dili",
            "dav": "taita dili",
            "de": "nemes dili",
            "de-AT": "nemes dili (Awstriýa)",
            "de-CH": "ýokarky nemes dili (Şweýsariýa)",
            "dgr": "dogrib dili",
            "dje": "zarma dili",
            "doi": "Dogri",
            "dsb": "aşaky lužits dili",
            "dua": "duala dili",
            "dv": "diwehi dili",
            "dyo": "ýola-fonýi dili",
            "dz": "dzong-ke dili",
            "dzg": "daza dili",
            "ebu": "embu dili",
            "ee": "ewe dili",
            "efi": "efik dili",
            "eka": "ekajuk dili",
            "el": "grek dili",
            "en": "iňlis dili",
            "en-AU": "iňlis dili (Awstraliýa)",
            "en-CA": "iňlis dili (Kanada)",
            "en-GB": "iňlis dili (Beýik Britaniýa)",
            "en-US": "iňlis dili (Amerika)",
            "eo": "esperanto dili",
            "es": "ispan dili",
            "es-419": "ispan dili (Latyn Amerikasy)",
            "es-ES": "ispan dili (Ýewropa)",
            "es-MX": "ispan dili (Meksika)",
            "et": "eston dili",
            "eu": "bask dili",
            "ewo": "ewondo dili",
            "fa": "pars dili",
            "fa-AF": "dari dili",
            "ff": "fula dili",
            "fi": "fin dili",
            "fil": "filippin dili",
            "fj": "fiji dili",
            "fo": "farer dili",
            "fon": "fon dili",
            "fr": "fransuz dili",
            "fr-CA": "fransuz dili (Kanada)",
            "fr-CH": "fransuz dili (Şweýsariýa)",
            "frc": "frc",
            "fur": "friul dili",
            "fy": "günbatar friz dili",
            "ga": "irland dili",
            "gaa": "ga dili",
            "gd": "şotland kelt dili",
            "gez": "geez dili",
            "gil": "gilbert dili",
            "gl": "galisiý dili",
            "gn": "guarani dili",
            "gor": "gorontalo dili",
            "gsw": "nemes dili (Şweýsariýa)",
            "gu": "gujarati dili",
            "guz": "gusii dili",
            "gv": "men dili",
            "gwi": "gwiçin dili",
            "ha": "hausa dili",
            "haw": "gawaý dili",
            "he": "ýewreý dili",
            "hi": "hindi dili",
            "hil": "hiligaýnon dili",
            "hmn": "hmong dili",
            "hr": "horwat dili",
            "hsb": "ýokarky lužits dili",
            "ht": "gaiti kreol dili",
            "hu": "wenger dili",
            "hup": "hupa",
            "hy": "ermeni dili",
            "hz": "gerero dili",
            "ia": "interlingwa dili",
            "iba": "iban dili",
            "ibb": "ibibio dili",
            "id": "indonez dili",
            "ig": "igbo dili",
            "ii": "syçuan-i dili",
            "ilo": "iloko dili",
            "inh": "inguş dili",
            "io": "ido dili",
            "is": "island dili",
            "it": "italýan dili",
            "iu": "inuktitut dili",
            "ja": "ýapon dili",
            "jbo": "lojban dili",
            "jgo": "ngomba dili",
            "jmc": "maçame dili",
            "jv": "ýawa dili",
            "ka": "gruzin dili",
            "kab": "kabil dili",
            "kac": "kaçin dili",
            "kaj": "ju dili",
            "kam": "kamba dili",
            "kbd": "kabardin dili",
            "kcg": "tiap dili",
            "kde": "makonde dili",
            "kea": "kabuwerdianu dili",
            "kfo": "koro dili",
            "kgp": "kgp",
            "kha": "khasi dili",
            "khq": "koýra-çini dili",
            "ki": "kikuýu dili",
            "kj": "kwanýama dili",
            "kk": "gazak dili",
            "kkj": "kako dili",
            "kl": "grenland dili",
            "kln": "kalenjin dili",
            "km": "khmer dili",
            "kmb": "kimbundu dili",
            "kn": "kannada dili",
            "ko": "koreý dili",
            "kok": "konkani dili",
            "kpe": "kpelle dili",
            "kr": "kanuri",
            "krc": "karaçaý-balkar dili",
            "krl": "karel dili",
            "kru": "kuruh dili",
            "ks": "kaşmiri dili",
            "ksb": "şambala dili",
            "ksf": "bafia dili",
            "ksh": "keln dili",
            "ku": "kürt dili",
            "kum": "kumyk dili",
            "kv": "komi dili",
            "kw": "korn dili",
            "ky": "gyrgyz dili",
            "la": "latyn dili",
            "lad": "ladino dili",
            "lag": "langi dili",
            "lb": "lýuksemburg dili",
            "lez": "lezgin dili",
            "lg": "ganda dili",
            "li": "limburg dili",
            "lij": "lij",
            "lkt": "lakota dili",
            "ln": "lingala dili",
            "lo": "laos dili",
            "lou": "lou",
            "loz": "lozi dili",
            "lrc": "demirgazyk luri dili",
            "lt": "litwa dili",
            "lu": "luba-katanga dili",
            "lua": "luba-Lulua dili",
            "lun": "lunda dili",
            "luo": "luo dili",
            "lus": "mizo dili",
            "luy": "luýýa dili",
            "lv": "latyş dili",
            "mad": "madur dili",
            "mag": "magahi dili",
            "mai": "maýthili dili",
            "mak": "makasar dili",
            "mas": "masai dili",
            "mdf": "mokşa dili",
            "men": "mende dili",
            "mer": "meru dili",
            "mfe": "morisýen dili",
            "mg": "malagasiý dili",
            "mgh": "makuwa-mito dili",
            "mgo": "meta dili",
            "mh": "marşall dili",
            "mi": "maori dili",
            "mic": "mikmak dili",
            "min": "minangkabau dili",
            "mk": "makedon dili",
            "ml": "malaýalam dili",
            "mn": "mongol dili",
            "mni": "manipuri dili",
            "moh": "mogauk dili",
            "mos": "mossi dili",
            "mr": "marathi dili",
            "ms": "malaý dili",
            "mt": "malta dili",
            "mua": "mundang dili",
            "mul": "birnäçe dil",
            "mus": "krik dili",
            "mwl": "mirand dili",
            "my": "birma dili",
            "myv": "erzýan dili",
            "mzn": "mazanderan dili",
            "na": "nauru dili",
            "nap": "neapolitan dili",
            "naq": "nama dili",
            "nb": "norwegiýa bukmol dili",
            "nd": "demirgazyk ndebele dili",
            "nds": "aşaky nemes dili",
            "nds-NL": "aşaky nemes dili (Niderlandlar)",
            "ne": "nepal dili",
            "new": "newari dili",
            "ng": "ndonga dili",
            "nia": "nias dili",
            "niu": "niue dili",
            "nl": "niderland dili",
            "nl-BE": "flamand dili",
            "nmg": "kwasio dili",
            "nn": "norwegiýa nýunorsk dili",
            "nnh": "ngembun dili",
            "no": "norweg dili",
            "nog": "nogaý dili",
            "nqo": "nko dili",
            "nr": "günorta ndebele dili",
            "nso": "demirgazyk soto dili",
            "nus": "nuer dili",
            "nv": "nawaho dili",
            "ny": "nýanja dili",
            "nyn": "nýankole dili",
            "oc": "oksitan dili",
            "om": "oromo dili",
            "or": "oriýa dili",
            "os": "osetin dili",
            "pa": "penjab dili",
            "pag": "pangansinan dili",
            "pam": "kapampangan dili",
            "pap": "papýamento dili",
            "pau": "palau dili",
            "pcm": "nigeriýa-pijin dili",
            "pl": "polýak dili",
            "prg": "prussiýa dili",
            "ps": "peştun dili",
            "pt": "portugal dili",
            "pt-BR": "portugal dili (Braziliýa)",
            "pt-PT": "portugal dili (Ýewropa)",
            "qu": "keçua dili",
            "quc": "kiçe dili",
            "rap": "rapanuý dili",
            "rar": "kuk dili",
            "rhg": "rohinýa dili",
            "rm": "retoroman dili",
            "rn": "rundi dili",
            "ro": "rumyn dili",
            "ro-MD": "moldaw dili",
            "rof": "rombo dili",
            "ru": "rus dili",
            "rup": "arumyn dili",
            "rw": "kinýaruanda dili",
            "rwk": "rwa dili",
            "sa": "sanskrit dili",
            "sad": "sandawe dili",
            "sah": "ýakut dili",
            "saq": "samburu dili",
            "sat": "santali dili",
            "sba": "ngambaý dili",
            "sbp": "sangu dili",
            "sc": "sardin dili",
            "scn": "sisiliýa dili",
            "sco": "şotland dili",
            "sd": "sindhi dili",
            "se": "demirgazyk saam dili",
            "seh": "sena dili",
            "ses": "koýraboro-senni dili",
            "sg": "sango dili",
            "shi": "tahelhit dili",
            "shn": "şan dili",
            "si": "singal dili",
            "sk": "slowak dili",
            "sl": "slowen dili",
            "sm": "samoa dili",
            "sma": "günorta saam dili",
            "smj": "lule-saam dili",
            "smn": "inari-saam dili",
            "sms": "skolt-saam dili",
            "sn": "şona dili",
            "snk": "soninke dili",
            "so": "somali dili",
            "sq": "alban dili",
            "sr": "serb dili",
            "srn": "sranan-tongo dili",
            "ss": "swati dili",
            "ssy": "saho dili",
            "st": "günorta soto dili",
            "su": "sundan dili",
            "suk": "sukuma dili",
            "sv": "şwed dili",
            "sw": "suahili dili",
            "sw-CD": "kongo suahili dili",
            "swb": "komor dili",
            "syr": "siriýa dili",
            "ta": "tamil dili",
            "te": "telugu dili",
            "tem": "temne dili",
            "teo": "teso dili",
            "tet": "tetum dili",
            "tg": "täjik dili",
            "th": "taý dili",
            "ti": "tigrinýa dili",
            "tig": "tigre dili",
            "tk": "türkmen dili",
            "tlh": "klingon dili",
            "tn": "tswana dili",
            "to": "tongan dili",
            "tpi": "tok-pisin dili",
            "tr": "türk dili",
            "trv": "taroko dili",
            "ts": "tsonga dili",
            "tt": "tatar dili",
            "tum": "tumbuka dili",
            "tvl": "tuwalu dili",
            "twq": "tasawak dili",
            "ty": "taiti dili",
            "tyv": "tuwa dili",
            "tzm": "orta-atlas tamazight dili",
            "udm": "udmurt dili",
            "ug": "uýgur dili",
            "uk": "ukrain dili",
            "umb": "umbundu dili",
            "und": "näbelli dil",
            "ur": "urdu",
            "uz": "özbek dili",
            "vai": "wai dili",
            "ve": "wenda dili",
            "vi": "wýetnam dili",
            "vo": "wolapýuk dili",
            "vun": "wunýo dili",
            "wa": "wallon dili",
            "wae": "walzer dili",
            "wal": "wolaýta dili",
            "war": "waraý dili",
            "wo": "wolof dili",
            "xal": "galmyk dili",
            "xh": "kosa dili",
            "xog": "soga dili",
            "yav": "ýangben dili",
            "ybb": "ýemba dili",
            "yi": "idiş dili",
            "yo": "ýoruba dili",
            "yrl": "yrl",
            "yue": "kanton dili",
            "zgh": "standart Marokko tamazight dili",
            "zh": "hytaý dili",
            "zh-Hans": "ýönekeýleşdirilen hytaý dili",
            "zh-Hant": "adaty hytaý dili",
            "zu": "zulu dili",
            "zun": "zuni dili",
            "zxx": "dilçilige degişli mazmun ýok",
            "zza": "zazaki dili"
          },
          "narrow": {
          },
          "short": {
            "az": "azeri dili",
            "en-GB": "iňlis dili (Beýik Britaniýa)",
            "en-US": "iňlis dili (Amerika)"
          }
        },
        "standard": {
          "long": {
            "aa": "afar dili",
            "ab": "abhaz dili",
            "ace": "açeh dili",
            "ada": "adangme dili",
            "ady": "adygeý dili",
            "af": "afrikaans dili",
            "agq": "ahem dili",
            "ain": "aýn dili",
            "ak": "akan dili",
            "ale": "aleut dili",
            "alt": "günorta Altaý dili",
            "am": "amhar dili",
            "an": "aragon dili",
            "anp": "angika dili",
            "ar": "arap dili",
            "ar-001": "arap dili (Dünýä)",
            "arn": "mapuçe dili",
            "arp": "arapaho dili",
            "as": "assam dili",
            "asa": "asu dili",
            "ast": "asturiý dili",
            "av": "awar dili",
            "awa": "awadhi dili",
            "ay": "aýmara dili",
            "az": "azerbaýjan dili",
            "ba": "başgyrt dili",
            "ban": "baliý dili",
            "bas": "basaa dili",
            "be": "belarus dili",
            "bem": "bemba dili",
            "bez": "bena dili",
            "bg": "bolgar dili",
            "bho": "bhojpuri dili",
            "bi": "bislama dili",
            "bin": "bini dili",
            "bla": "siksika dili",
            "bm": "bamana",
            "bn": "bengal dili",
            "bo": "tibet dili",
            "br": "breton dili",
            "brx": "bodo dili",
            "bs": "bosniýa dili",
            "bug": "bugiý dili",
            "byn": "blin dili",
            "ca": "katalan dili",
            "ccp": "çakma dili",
            "ce": "çeçen dili",
            "ceb": "sebuan dili",
            "cgg": "kiga",
            "ch": "çamorro",
            "chk": "çuuk dili",
            "chm": "mariý dili",
            "cho": "çokto",
            "chr": "çeroki",
            "chy": "şaýenn dili",
            "ckb": "merkezi kürt dili",
            "co": "korsikan dili",
            "crs": "seselwa kreole-fransuz dili",
            "cs": "çeh dili",
            "cu": "buthana slaw dili",
            "cv": "çuwaş dili",
            "cy": "walliý dili",
            "da": "daniýa dili",
            "dak": "dakota dili",
            "dar": "dargi dili",
            "dav": "taita dili",
            "de": "nemes dili",
            "de-AT": "nemes dili (Awstriýa)",
            "de-CH": "nemes dili (Şweýsariýa)",
            "dgr": "dogrib dili",
            "dje": "zarma dili",
            "doi": "Dogri",
            "dsb": "aşaky lužits dili",
            "dua": "duala dili",
            "dv": "diwehi dili",
            "dyo": "ýola-fonýi dili",
            "dz": "dzong-ke dili",
            "dzg": "daza dili",
            "ebu": "embu dili",
            "ee": "ewe dili",
            "efi": "efik dili",
            "eka": "ekajuk dili",
            "el": "grek dili",
            "en": "iňlis dili",
            "en-AU": "iňlis dili (Awstraliýa)",
            "en-CA": "iňlis dili (Kanada)",
            "en-GB": "iňlis dili (Birleşen Patyşalyk)",
            "en-US": "iňlis dili (Amerikanyň Birleşen Ştatlary)",
            "eo": "esperanto dili",
            "es": "ispan dili",
            "es-419": "ispan dili (Latyn Amerikasy)",
            "es-ES": "ispan dili (Ispaniýa)",
            "es-MX": "ispan dili (Meksika)",
            "et": "eston dili",
            "eu": "bask dili",
            "ewo": "ewondo dili",
            "fa": "pars dili",
            "fa-AF": "pars dili (Owganystan)",
            "ff": "fula dili",
            "fi": "fin dili",
            "fil": "filippin dili",
            "fj": "fiji dili",
            "fo": "farer dili",
            "fon": "fon dili",
            "fr": "fransuz dili",
            "fr-CA": "fransuz dili (Kanada)",
            "fr-CH": "fransuz dili (Şweýsariýa)",
            "frc": "frc",
            "fur": "friul dili",
            "fy": "günbatar friz dili",
            "ga": "irland dili",
            "gaa": "ga dili",
            "gd": "şotland kelt dili",
            "gez": "geez dili",
            "gil": "gilbert dili",
            "gl": "galisiý dili",
            "gn": "guarani dili",
            "gor": "gorontalo dili",
            "gsw": "nemes dili (Şweýsariýa)",
            "gu": "gujarati dili",
            "guz": "gusii dili",
            "gv": "men dili",
            "gwi": "gwiçin dili",
            "ha": "hausa dili",
            "haw": "gawaý dili",
            "he": "ýewreý dili",
            "hi": "hindi dili",
            "hil": "hiligaýnon dili",
            "hmn": "hmong dili",
            "hr": "horwat dili",
            "hsb": "ýokarky lužits dili",
            "ht": "gaiti kreol dili",
            "hu": "wenger dili",
            "hup": "hupa",
            "hy": "ermeni dili",
            "hz": "gerero dili",
            "ia": "interlingwa dili",
            "iba": "iban dili",
            "ibb": "ibibio dili",
            "id": "indonez dili",
            "ig": "igbo dili",
            "ii": "syçuan-i dili",
            "ilo": "iloko dili",
            "inh": "inguş dili",
            "io": "ido dili",
            "is": "island dili",
            "it": "italýan dili",
            "iu": "inuktitut dili",
            "ja": "ýapon dili",
            "jbo": "lojban dili",
            "jgo": "ngomba dili",
            "jmc": "maçame dili",
            "jv": "ýawa dili",
            "ka": "gruzin dili",
            "kab": "kabil dili",
            "kac": "kaçin dili",
            "kaj": "ju dili",
            "kam": "kamba dili",
            "kbd": "kabardin dili",
            "kcg": "tiap dili",
            "kde": "makonde dili",
            "kea": "kabuwerdianu dili",
            "kfo": "koro dili",
            "kgp": "kgp",
            "kha": "khasi dili",
            "khq": "koýra-çini dili",
            "ki": "kikuýu dili",
            "kj": "kwanýama dili",
            "kk": "gazak dili",
            "kkj": "kako dili",
            "kl": "grenland dili",
            "kln": "kalenjin dili",
            "km": "khmer dili",
            "kmb": "kimbundu dili",
            "kn": "kannada dili",
            "ko": "koreý dili",
            "kok": "konkani dili",
            "kpe": "kpelle dili",
            "kr": "kanuri",
            "krc": "karaçaý-balkar dili",
            "krl": "karel dili",
            "kru": "kuruh dili",
            "ks": "kaşmiri dili",
            "ksb": "şambala dili",
            "ksf": "bafia dili",
            "ksh": "keln dili",
            "ku": "kürt dili",
            "kum": "kumyk dili",
            "kv": "komi dili",
            "kw": "korn dili",
            "ky": "gyrgyz dili",
            "la": "latyn dili",
            "lad": "ladino dili",
            "lag": "langi dili",
            "lb": "lýuksemburg dili",
            "lez": "lezgin dili",
            "lg": "ganda dili",
            "li": "limburg dili",
            "lij": "lij",
            "lkt": "lakota dili",
            "ln": "lingala dili",
            "lo": "laos dili",
            "lou": "lou",
            "loz": "lozi dili",
            "lrc": "demirgazyk luri dili",
            "lt": "litwa dili",
            "lu": "luba-katanga dili",
            "lua": "luba-Lulua dili",
            "lun": "lunda dili",
            "luo": "luo dili",
            "lus": "mizo dili",
            "luy": "luýýa dili",
            "lv": "latyş dili",
            "mad": "madur dili",
            "mag": "magahi dili",
            "mai": "maýthili dili",
            "mak": "makasar dili",
            "mas": "masai dili",
            "mdf": "mokşa dili",
            "men": "mende dili",
            "mer": "meru dili",
            "mfe": "morisýen dili",
            "mg": "malagasiý dili",
            "mgh": "makuwa-mito dili",
            "mgo": "meta dili",
            "mh": "marşall dili",
            "mi": "maori dili",
            "mic": "mikmak dili",
            "min": "minangkabau dili",
            "mk": "makedon dili",
            "ml": "malaýalam dili",
            "mn": "mongol dili",
            "mni": "manipuri dili",
            "moh": "mogauk dili",
            "mos": "mossi dili",
            "mr": "marathi dili",
            "ms": "malaý dili",
            "mt": "malta dili",
            "mua": "mundang dili",
            "mul": "birnäçe dil",
            "mus": "krik dili",
            "mwl": "mirand dili",
            "my": "birma dili",
            "myv": "erzýan dili",
            "mzn": "mazanderan dili",
            "na": "nauru dili",
            "nap": "neapolitan dili",
            "naq": "nama dili",
            "nb": "norwegiýa bukmol dili",
            "nd": "demirgazyk ndebele dili",
            "nds": "aşaky nemes dili",
            "nds-NL": "aşaky nemes dili (Niderlandlar)",
            "ne": "nepal dili",
            "new": "newari dili",
            "ng": "ndonga dili",
            "nia": "nias dili",
            "niu": "niue dili",
            "nl": "niderland dili",
            "nl-BE": "niderland dili (Belgiýa)",
            "nmg": "kwasio dili",
            "nn": "norwegiýa nýunorsk dili",
            "nnh": "ngembun dili",
            "no": "norweg dili",
            "nog": "nogaý dili",
            "nqo": "nko dili",
            "nr": "günorta ndebele dili",
            "nso": "demirgazyk soto dili",
            "nus": "nuer dili",
            "nv": "nawaho dili",
            "ny": "nýanja dili",
            "nyn": "nýankole dili",
            "oc": "oksitan dili",
            "om": "oromo dili",
            "or": "oriýa dili",
            "os": "osetin dili",
            "pa": "penjab dili",
            "pag": "pangansinan dili",
            "pam": "kapampangan dili",
            "pap": "papýamento dili",
            "pau": "palau dili",
            "pcm": "nigeriýa-pijin dili",
            "pl": "polýak dili",
            "prg": "prussiýa dili",
            "ps": "peştun dili",
            "pt": "portugal dili",
            "pt-BR": "portugal dili (Braziliýa)",
            "pt-PT": "portugal dili (Portugaliýa)",
            "qu": "keçua dili",
            "quc": "kiçe dili",
            "rap": "rapanuý dili",
            "rar": "kuk dili",
            "rhg": "rohinýa dili",
            "rm": "retoroman dili",
            "rn": "rundi dili",
            "ro": "rumyn dili",
            "ro-MD": "rumyn dili (Moldowa)",
            "rof": "rombo dili",
            "ru": "rus dili",
            "rup": "arumyn dili",
            "rw": "kinýaruanda dili",
            "rwk": "rwa dili",
            "sa": "sanskrit dili",
            "sad": "sandawe dili",
            "sah": "ýakut dili",
            "saq": "samburu dili",
            "sat": "santali dili",
            "sba": "ngambaý dili",
            "sbp": "sangu dili",
            "sc": "sardin dili",
            "scn": "sisiliýa dili",
            "sco": "şotland dili",
            "sd": "sindhi dili",
            "se": "demirgazyk saam dili",
            "seh": "sena dili",
            "ses": "koýraboro-senni dili",
            "sg": "sango dili",
            "shi": "tahelhit dili",
            "shn": "şan dili",
            "si": "singal dili",
            "sk": "slowak dili",
            "sl": "slowen dili",
            "sm": "samoa dili",
            "sma": "günorta saam dili",
            "smj": "lule-saam dili",
            "smn": "inari-saam dili",
            "sms": "skolt-saam dili",
            "sn": "şona dili",
            "snk": "soninke dili",
            "so": "somali dili",
            "sq": "alban dili",
            "sr": "serb dili",
            "srn": "sranan-tongo dili",
            "ss": "swati dili",
            "ssy": "saho dili",
            "st": "günorta soto dili",
            "su": "sundan dili",
            "suk": "sukuma dili",
            "sv": "şwed dili",
            "sw": "suahili dili",
            "sw-CD": "suahili dili (Kongo - Kinşasa)",
            "swb": "komor dili",
            "syr": "siriýa dili",
            "ta": "tamil dili",
            "te": "telugu dili",
            "tem": "temne dili",
            "teo": "teso dili",
            "tet": "tetum dili",
            "tg": "täjik dili",
            "th": "taý dili",
            "ti": "tigrinýa dili",
            "tig": "tigre dili",
            "tk": "türkmen dili",
            "tlh": "klingon dili",
            "tn": "tswana dili",
            "to": "tongan dili",
            "tpi": "tok-pisin dili",
            "tr": "türk dili",
            "trv": "taroko dili",
            "ts": "tsonga dili",
            "tt": "tatar dili",
            "tum": "tumbuka dili",
            "tvl": "tuwalu dili",
            "twq": "tasawak dili",
            "ty": "taiti dili",
            "tyv": "tuwa dili",
            "tzm": "orta-atlas tamazight dili",
            "udm": "udmurt dili",
            "ug": "uýgur dili",
            "uk": "ukrain dili",
            "umb": "umbundu dili",
            "und": "näbelli dil",
            "ur": "urdu",
            "uz": "özbek dili",
            "vai": "wai dili",
            "ve": "wenda dili",
            "vi": "wýetnam dili",
            "vo": "wolapýuk dili",
            "vun": "wunýo dili",
            "wa": "wallon dili",
            "wae": "walzer dili",
            "wal": "wolaýta dili",
            "war": "waraý dili",
            "wo": "wolof dili",
            "xal": "galmyk dili",
            "xh": "kosa dili",
            "xog": "soga dili",
            "yav": "ýangben dili",
            "ybb": "ýemba dili",
            "yi": "idiş dili",
            "yo": "ýoruba dili",
            "yrl": "yrl",
            "yue": "kanton dili",
            "zgh": "standart Marokko tamazight dili",
            "zh": "hytaý dili",
            "zh-Hans": "ýönekeýleşdirilen hytaý dili",
            "zh-Hant": "adaty hytaý dili",
            "zu": "zulu dili",
            "zun": "zuni dili",
            "zxx": "dilçilige degişli mazmun ýok",
            "zza": "zazaki dili"
          },
          "narrow": {
          },
          "short": {
            "az": "azeri dili",
            "en-GB": "iňlis dili (Birleşen Patyşalyk)",
            "en-US": "iňlis dili (ABŞ)"
          }
        }
      },
      "region": {
        "long": {
          "001": "Dünýä",
          "002": "Afrika",
          "003": "Demirgazyk Amerika",
          "005": "Günorta Amerika",
          "009": "Okeaniýa",
          "011": "Günbatar Afrika",
          "013": "Orta Amerika",
          "014": "Gündogar Afrika",
          "015": "Demirgazyk Afrika",
          "017": "Orta Afrika",
          "018": "Afrikanyň günorta sebitleri",
          "019": "Amerika",
          "021": "Amerikanyň demirgazyk ýurtlary",
          "029": "Karib basseýni",
          "030": "Gündogar Aziýa",
          "034": "Günorta Aziýa",
          "035": "Günorta-gündogar Aziýa",
          "039": "Günorta Ýewropa",
          "053": "Awstralaziýa",
          "054": "Melaneziýa",
          "057": "Mikroneziýa sebti",
          "061": "Polineziýa",
          "142": "Aziýa",
          "143": "Merkezi Aziýa",
          "145": "Günbatar Aziýa",
          "150": "Ýewropa",
          "151": "Gündogar Ýewropa",
          "154": "Demirgazyk Ýewropa",
          "155": "Günbatar Ýewropa",
          "202": "Saharadan aşakdaky Afrika",
          "419": "Latyn Amerikasy",
          "AC": "Beýgeliş adasy",
          "AD": "Andorra",
          "AE": "Birleşen Arap Emirlikleri",
          "AF": "Owganystan",
          "AG": "Antigua we Barbuda",
          "AI": "Angilýa",
          "AL": "Albaniýa",
          "AM": "Ermenistan",
          "AO": "Angola",
          "AQ": "Antarktika",
          "AR": "Argentina",
          "AS": "Amerikan Samoasy",
          "AT": "Awstriýa",
          "AU": "Awstraliýa",
          "AW": "Aruba",
          "AX": "Aland adalary",
          "AZ": "Azerbaýjan",
          "BA": "Bosniýa we Gersegowina",
          "BB": "Barbados",
          "BD": "Bangladeş",
          "BE": "Belgiýa",
          "BF": "Burkina-Faso",
          "BG": "Bolgariýa",
          "BH": "Bahreýn",
          "BI": "Burundi",
          "BJ": "Benin",
          "BL": "Sen-Bartelemi",
          "BM": "Bermuda",
          "BN": "Bruneý",
          "BO": "Boliwiýa",
          "BQ": "Karib Niderlandlary",
          "BR": "Braziliýa",
          "BS": "Bagama adalary",
          "BT": "Butan",
          "BV": "Buwe adasy",
          "BW": "Botswana",
          "BY": "Belarus",
          "BZ": "Beliz",
          "CA": "Kanada",
          "CC": "Kokos (Kiling) adalary",
          "CD": "Kongo - Kinşasa",
          "CF": "Merkezi Afrika Respublikasy",
          "CG": "Kongo - Brazzawil",
          "CH": "Şweýsariýa",
          "CI": "Kot-d’Iwuar",
          "CK": "Kuk adalary",
          "CL": "Çili",
          "CM": "Kamerun",
          "CN": "Hytaý",
          "CO": "Kolumbiýa",
          "CP": "Klipperton adasy",
          "CR": "Kosta-Rika",
          "CU": "Kuba",
          "CV": "Kabo-Werde",
          "CW": "Kýurasao",
          "CX": "Roždestwo adasy",
          "CY": "Kipr",
          "CZ": "Çehiýa",
          "DE": "Germaniýa",
          "DG": "Diýego-Garsiýa",
          "DJ": "Jibuti",
          "DK": "Daniýa",
          "DM": "Dominika",
          "DO": "Dominikan Respublikasy",
          "DZ": "Alžir",
          "EA": "Seuta we Melilýa",
          "EC": "Ekwador",
          "EE": "Estoniýa",
          "EG": "Müsür",
          "EH": "Günbatar Sahara",
          "ER": "Eritreýa",
          "ES": "Ispaniýa",
          "ET": "Efiopiýa",
          "EU": "Ýewropa Bileleşigi",
          "EZ": "Ýewro sebiti",
          "FI": "Finlýandiýa",
          "FJ": "Fiji",
          "FK": "Folklend adalary",
          "FM": "Mikroneziýa",
          "FO": "Farer adalary",
          "FR": "Fransiýa",
          "GA": "Gabon",
          "GB": "Birleşen Patyşalyk",
          "GD": "Grenada",
          "GE": "Gruziýa",
          "GF": "Fransuz Gwianasy",
          "GG": "Gernsi",
          "GH": "Gana",
          "GI": "Gibraltar",
          "GL": "Grenlandiýa",
          "GM": "Gambiýa",
          "GN": "Gwineýa",
          "GP": "Gwadelupa",
          "GQ": "Ekwatorial Gwineýa",
          "GR": "Gresiýa",
          "GS": "Günorta Georgiýa we Günorta Sendwiç adasy",
          "GT": "Gwatemala",
          "GU": "Guam",
          "GW": "Gwineýa-Bisau",
          "GY": "Gaýana",
          "HK": "Gonkong AAS Hytaý",
          "HM": "Herd we Makdonald adalary",
          "HN": "Gonduras",
          "HR": "Horwatiýa",
          "HT": "Gaiti",
          "HU": "Wengriýa",
          "IC": "Kanar adalary",
          "ID": "Indoneziýa",
          "IE": "Irlandiýa",
          "IL": "Ysraýyl",
          "IM": "Men adasy",
          "IN": "Hindistan",
          "IO": "Britaniýanyň Hindi okeanyndaky territoriýalary",
          "IQ": "Yrak",
          "IR": "Eýran",
          "IS": "Islandiýa",
          "IT": "Italiýa",
          "JE": "Jersi",
          "JM": "Ýamaýka",
          "JO": "Iordaniýa",
          "JP": "Ýaponiýa",
          "KE": "Keniýa",
          "KG": "Gyrgyzystan",
          "KH": "Kamboja",
          "KI": "Kiribati",
          "KM": "Komor adalary",
          "KN": "Sent-Kits we Newis",
          "KP": "Demirgazyk Koreýa",
          "KR": "Günorta Koreýa",
          "KW": "Kuweýt",
          "KY": "Kaýman adalary",
          "KZ": "Gazagystan",
          "LA": "Laos",
          "LB": "Liwan",
          "LC": "Sent-Lýusiýa",
          "LI": "Lihtenşteýn",
          "LK": "Şri-Lanka",
          "LR": "Liberiýa",
          "LS": "Lesoto",
          "LT": "Litwa",
          "LU": "Lýuksemburg",
          "LV": "Latwiýa",
          "LY": "Liwiýa",
          "MA": "Marokko",
          "MC": "Monako",
          "MD": "Moldowa",
          "ME": "Çernogoriýa",
          "MF": "Sen-Marten",
          "MG": "Madagaskar",
          "MH": "Marşall adalary",
          "MK": "Demirgazyk Makedoniýa",
          "ML": "Mali",
          "MM": "Mýanma (Birma)",
          "MN": "Mongoliýa",
          "MO": "Makao AAS Hytaý",
          "MP": "Demirgazyk Mariana adalary",
          "MQ": "Martinika",
          "MR": "Mawritaniýa",
          "MS": "Monserrat",
          "MT": "Malta",
          "MU": "Mawrikiý",
          "MV": "Maldiwler",
          "MW": "Malawi",
          "MX": "Meksika",
          "MY": "Malaýziýa",
          "MZ": "Mozambik",
          "NA": "Namibiýa",
          "NC": "Täze Kaledoniýa",
          "NE": "Niger",
          "NF": "Norfolk adasy",
          "NG": "Nigeriýa",
          "NI": "Nikaragua",
          "NL": "Niderlandlar",
          "NO": "Norwegiýa",
          "NP": "Nepal",
          "NR": "Nauru",
          "NU": "Niue",
          "NZ": "Täze Zelandiýa",
          "OM": "Oman",
          "PA": "Panama",
          "PE": "Peru",
          "PF": "Fransuz Polineziýasy",
          "PG": "Papua - Täze Gwineýa",
          "PH": "Filippinler",
          "PK": "Pakistan",
          "PL": "Polşa",
          "PM": "Sen-Pýer we Mikelon",
          "PN": "Pitkern adalary",
          "PR": "Puerto-Riko",
          "PS": "Palestina territoriýasy",
          "PT": "Portugaliýa",
          "PW": "Palau",
          "PY": "Paragwaý",
          "QA": "Katar",
          "QO": "Daşky Okeaniýa",
          "RE": "Reýunýon",
          "RO": "Rumyniýa",
          "RS": "Serbiýa",
          "RU": "Russiýa",
          "RW": "Ruanda",
          "SA": "Saud Arabystany",
          "SB": "Solomon adalary",
          "SC": "Seýşel adalary",
          "SD": "Sudan",
          "SE": "Şwesiýa",
          "SG": "Singapur",
          "SH": "Keramatly Ýelena adasy",
          "SI": "Sloweniýa",
          "SJ": "Şpisbergen we Ýan-Maýen",
          "SK": "Slowakiýa",
          "SL": "Sýerra-Leone",
          "SM": "San-Marino",
          "SN": "Senegal",
          "SO": "Somali",
          "SR": "Surinam",
          "SS": "Günorta Sudan",
          "ST": "San-Tome we Prinsipi",
          "SV": "Salwador",
          "SX": "Sint-Marten",
          "SY": "Siriýa",
          "SZ": "Eswatini",
          "TA": "Tristan-da-Kunýa",
          "TC": "Terks we Kaýkos adalary",
          "TD": "Çad",
          "TF": "Fransuz günorta territoriýalary",
          "TG": "Togo",
          "TH": "Taýland",
          "TJ": "Täjigistan",
          "TK": "Tokelau",
          "TL": "Timor-Leste",
          "TM": "Türkmenistan",
          "TN": "Tunis",
          "TO": "Tonga",
          "TR": "Türkiýe",
          "TT": "Trinidad we Tobago",
          "TV": "Tuwalu",
          "TW": "Taýwan",
          "TZ": "Tanzaniýa",
          "UA": "Ukraina",
          "UG": "Uganda",
          "UM": "ABŞ-nyň daşarky adalary",
          "UN": "Birleşen Milletler Guramasy",
          "US": "Amerikanyň Birleşen Ştatlary",
          "UY": "Urugwaý",
          "UZ": "Özbegistan",
          "VA": "Watikan",
          "VC": "Sent-Winsent we Grenadinler",
          "VE": "Wenesuela",
          "VG": "Britan Wirgin adalary",
          "VI": "ABŞ-nyň Wirgin adalary",
          "VN": "Wýetnam",
          "VU": "Wanuatu",
          "WF": "Uollis we Futuna",
          "WS": "Samoa",
          "XA": "psewdo-şiweler",
          "XB": "psewdo-bidi",
          "XK": "Kosowo",
          "YE": "Ýemen",
          "YT": "Maýotta",
          "ZA": "Günorta Afrika",
          "ZM": "Zambiýa",
          "ZW": "Zimbabwe",
          "ZZ": "Näbelli sebit"
        },
        "narrow": {
        },
        "short": {
          "GB": "Birleşen Patyşalyk",
          "HK": "Gonkong",
          "MO": "Makao",
          "PS": "Palestina",
          "US": "ABŞ"
        }
      },
      "script": {
        "long": {
          "Adlm": "Adlm",
          "Aghb": "Aghb",
          "Ahom": "Ahom",
          "Arab": "Arap elipbiýi",
          "Aran": "Aran",
          "Armi": "Armi",
          "Armn": "Ermeni elipbiýi",
          "Avst": "Avst",
          "Bali": "Bali",
          "Bamu": "Bamu",
          "Bass": "Bass",
          "Batk": "Batk",
          "Beng": "Bengal elipbiýi",
          "Bhks": "Bhks",
          "Bopo": "Bopomofo elipbiýi",
          "Brah": "Brah",
          "Brai": "Braýl elipbiýi",
          "Bugi": "Bugi",
          "Buhd": "Buhd",
          "Cakm": "Cakm",
          "Cans": "Cans",
          "Cari": "Cari",
          "Cham": "Cham",
          "Cher": "Cher",
          "Chrs": "Chrs",
          "Copt": "Copt",
          "Cpmn": "Cpmn",
          "Cprt": "Cprt",
          "Cyrl": "Kiril elipbiýi",
          "Deva": "Dewanagari elipbiýi",
          "Diak": "Diak",
          "Dogr": "Dogr",
          "Dsrt": "Dsrt",
          "Dupl": "Dupl",
          "Egyp": "Egyp",
          "Elba": "Elba",
          "Elym": "Elym",
          "Ethi": "Efiop elipbiýi",
          "Geor": "Gruzin elipbiýi",
          "Glag": "Glag",
          "Gong": "Gong",
          "Gonm": "Gonm",
          "Goth": "Goth",
          "Gran": "Gran",
          "Grek": "Grek elipbiýi",
          "Gujr": "Gujarati elipbiýi",
          "Guru": "Gurmuhi elipbiýi",
          "Hanb": "Bopomofo han elipbiýi",
          "Hang": "Hangyl elipbiýi",
          "Hani": "Han elipbiýi",
          "Hano": "Hano",
          "Hans": "Ýönekeýleşdirilen",
          "Hant": "Adaty",
          "Hatr": "Hatr",
          "Hebr": "Ýewreý elipbiýi",
          "Hira": "Hiragana elipbiýi",
          "Hluw": "Hluw",
          "Hmng": "Hmng",
          "Hmnp": "Hmnp",
          "Hrkt": "Ýapon bogun elipbiýleri",
          "Hung": "Hung",
          "Ital": "Ital",
          "Jamo": "Jamo elipbiýi",
          "Java": "Java",
          "Jpan": "Ýapon elipbiýi",
          "Kali": "Kali",
          "Kana": "Katakana elipbiýi",
          "Khar": "Khar",
          "Khmr": "Khmer elipbiýi",
          "Khoj": "Khoj",
          "Kits": "Kits",
          "Knda": "Kannada elipbiýi",
          "Kore": "Koreý elipbiýi",
          "Kthi": "Kthi",
          "Lana": "Lana",
          "Laoo": "Laos elipbiýi",
          "Latn": "Latyn elipbiýi",
          "Lepc": "Lepc",
          "Limb": "Limb",
          "Lina": "Lina",
          "Linb": "Linb",
          "Lisu": "Lisu",
          "Lyci": "Lyci",
          "Lydi": "Lydi",
          "Mahj": "Mahj",
          "Maka": "Maka",
          "Mand": "Mand",
          "Mani": "Mani",
          "Marc": "Marc",
          "Medf": "Medf",
          "Mend": "Mend",
          "Merc": "Merc",
          "Mero": "Mero",
          "Mlym": "Malaýalam elipbiýi",
          "Modi": "Modi",
          "Mong": "Mongol elipbiýi",
          "Mroo": "Mroo",
          "Mtei": "Mtei",
          "Mult": "Mult",
          "Mymr": "Mýanma elipbiýi",
          "Nand": "Nand",
          "Narb": "Narb",
          "Nbat": "Nbat",
          "Newa": "Newa",
          "Nkoo": "Nkoo",
          "Nshu": "Nshu",
          "Ogam": "Ogam",
          "Olck": "Olck",
          "Orkh": "Orkh",
          "Orya": "Oriýa elipbiýi",
          "Osge": "Osge",
          "Osma": "Osma",
          "Ougr": "Ougr",
          "Palm": "Palm",
          "Pauc": "Pauc",
          "Perm": "Perm",
          "Phag": "Phag",
          "Phli": "Phli",
          "Phlp": "Phlp",
          "Phnx": "Phnx",
          "Plrd": "Plrd",
          "Prti": "Prti",
          "Qaag": "Qaag",
          "Rjng": "Rjng",
          "Rohg": "Rohg",
          "Runr": "Runr",
          "Samr": "Samr",
          "Sarb": "Sarb",
          "Saur": "Saur",
          "Sgnw": "Sgnw",
          "Shaw": "Shaw",
          "Shrd": "Shrd",
          "Sidd": "Sidd",
          "Sind": "Sind",
          "Sinh": "Singal elipbiýi",
          "Sogd": "Sogd",
          "Sogo": "Sogo",
          "Sora": "Sora",
          "Soyo": "Soyo",
          "Sund": "Sund",
          "Sylo": "Sylo",
          "Syrc": "Syrc",
          "Tagb": "Tagb",
          "Takr": "Takr",
          "Tale": "Tale",
          "Talu": "Talu",
          "Taml": "Tamil elipbiýi",
          "Tang": "Tang",
          "Tavt": "Tavt",
          "Telu": "Telugu elipbiýi",
          "Tfng": "Tfng",
          "Tglg": "Tglg",
          "Thaa": "Taana elipbiýi",
          "Thai": "Taý elipbiýi",
          "Tibt": "Tibet elipbiýi",
          "Tirh": "Tirh",
          "Tnsa": "Tnsa",
          "Toto": "Toto",
          "Ugar": "Ugar",
          "Vaii": "Vaii",
          "Vith": "Vith",
          "Wara": "Wara",
          "Wcho": "Wcho",
          "Xpeo": "Xpeo",
          "Xsux": "Xsux",
          "Yezi": "Yezi",
          "Yiii": "Yiii",
          "Zanb": "Zanb",
          "Zinh": "Zinh",
          "Zmth": "Matematiki belgiler",
          "Zsye": "Emoji",
          "Zsym": "Nyşanlar",
          "Zxxx": "Ýazuwsyz",
          "Zyyy": "Umumy",
          "Zzzz": "Näbelli elipbiý"
        },
        "narrow": {
        },
        "short": {
        }
      }
    }
  },
  "locale": "tk"
})
}